import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from './Formats.module.css';
import { highlightPhrasesInChildren } from './highlightPhrases';

type ParagraphProps = {
  content: string;
  /** Phrases from chat search that should be marked in the transcript. */
  highlightPhrases?: string[] | null;
};

const Paragraph = ({ content, highlightPhrases }: ParagraphProps) => {
  const hasHighlights = !!highlightPhrases?.some((phrase) => phrase?.trim());

  return (
    <div className={styles.container} style={{ lineHeight: '1.5' }}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={
          hasHighlights
            ? {
                p: ({ children }) => (
                  <p>{highlightPhrasesInChildren(children, highlightPhrases)}</p>
                ),
                li: ({ children }) => (
                  <li>{highlightPhrasesInChildren(children, highlightPhrases)}</li>
                ),
                h1: ({ children }) => (
                  <h1>{highlightPhrasesInChildren(children, highlightPhrases)}</h1>
                ),
                h2: ({ children }) => (
                  <h2>{highlightPhrasesInChildren(children, highlightPhrases)}</h2>
                ),
                h3: ({ children }) => (
                  <h3>{highlightPhrasesInChildren(children, highlightPhrases)}</h3>
                ),
                h4: ({ children }) => (
                  <h4>{highlightPhrasesInChildren(children, highlightPhrases)}</h4>
                ),
                strong: ({ children }) => (
                  <strong>{highlightPhrasesInChildren(children, highlightPhrases)}</strong>
                ),
                em: ({ children }) => (
                  <em>{highlightPhrasesInChildren(children, highlightPhrases)}</em>
                ),
                blockquote: ({ children }) => (
                  <blockquote>
                    {highlightPhrasesInChildren(children, highlightPhrases)}
                  </blockquote>
                ),
              }
            : undefined
        }
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

// Markdown parsing is expensive; completed messages never change content, so skip
// re-rendering them when the page re-renders for streaming/typing updates.
export default React.memo(Paragraph);
